import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth';
import { useStockAlerts } from '@/hooks/useStockAlerts';

/**
 * Inner layout that uses hooks requiring AuthProvider context.
 */
function AuthenticatedShell() {
  useStockAlerts();
  return <Outlet />;
}

/**
 * Root layout that provides the AuthProvider context to all routes.
 */
export function RootLayout() {
  return (
    <AuthProvider>
      <AuthenticatedShell />
    </AuthProvider>
  );
}
